import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { loader_image } from "../_components/Imagepath";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik } from "formik";
import $ from "jquery";
import PropTypes from 'prop-types';
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
let season_id = localStorage.getItem("season_id");

 const formData={
    season_id:season_id,   
 };
const CnssList = () => {
  const [menu, setMenu] = useState(false);
  const [dataa, setDataa] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});
  const [locationLoading, setLocationLoading] = useState([]);
const genderlist = [
      { value: 'H', label: "H"},
      { value: 'F', label: "F" }
    ];
  

  useEffect(() => {
        setPermission(FindModuleById(453)); 
        console.log(permission);

                    axios
                    .get(`/helpers/loading-locations`, {
                      headers: {
                        Authorization: `Bearer ${Authtoken}`,
                        Apitoken: Apitoken,
                      },
                    })
                    .then((response) => {
                      if (response.data.code == 200) {
                        let locations = response.data.data.locations;
                        let emp_statusList = locations.map((ord, index) => ({
                          label:  ord.title ,
                          value: ord.id,
                          key: `sts-${index}`,
                        }));
                        
              
                        setLocationLoading(emp_statusList);
                     } else {
                        console.log("API response is not an array");
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
    axios.post("/employees/listing-active-emp-for-salary",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          //setEmployeesList(response.data.data.employees);
          let employees = response.data.data.employees;
          let emp_statusList = employees.map((ord, index) => ({
            label:  ord.first_name +' '+ord.last_name + ' ('+ord.emp_status.title+')',
            value: ord.id,
            key: `sts-${index}`,
          }));
          
  
          setEmployeesList(emp_statusList);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });

      axios.post("/employees/cnss-declared-listing",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        if (response.data.code === 200) {
          setDataa(response.data.data.cnss);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      }).catch((error) => {
        console.log(error);
      });
      axios.get("/helpers/employees-status", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if(response.data.code === 200){
          let emp_status = response.data.data.emp_status;
         // setPackagingTypesLists(materials_payment_status);
          let emp_statusList = emp_status.map((ord, index) => ({
            label:  ord.title ,
            value: ord.id,
            key: `sts-${index}`,
          }));
          setStatusOptions(emp_statusList);
      }else{
          console.log("API response is not an array");
        }
                
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);



  const {
    values,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
       season_id:season_id,
      employee_type:"",
      location:"",
      gender:"",
      shift:'',
      employee: [],  // ✅ Must be an array for multiple selection
      start_date: "",
      end_date: "",
    
    },
    onSubmit: (values, actions) => {
            const {  formatted } = getMonthYear(values.start_date);

      axios
        .post("/employees-generate-cnss-declarations", values, {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          
          const matchedLabels = employeesList
            .filter(item => values.employee.includes(item.value))
            .map(item => item.label);
          const namesString = matchedLabels.join(", ");
          
          // ✅ Change file extension to .xlsx
          // let file_name = `${namesString} ${values.start_date} ${values.end_date}.xlsx`;

          // const currentMonthYear = values.start_date ? getMonthYear(values.start_date).formatted : '';
                let file_name = `Suivi CNSS ${formatted} - ${namesString}Export Optimum.xlsx`;


          link.download = file_name;
          
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          actions.setSubmitting(false);
          // ✅ Update button text to reflect Excel download
          $("#form-submit").text("Suivi CNSS Excel");
                axios.post("/employees/cnss-declared-listing",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
                  .then((response) => {
                    if (response.data.code === 200) {
                      setDataa(response.data.data.cnss);
                    }
                    else  if (response.data.code === 401) {
                      window.location.href = "/login";
                    }else{
                      window.location.href = "/login"; 
                    }
                  }).catch((error) => {
                    console.log(error);
                  });
        })
        .catch((error) => {
          actions.setSubmitting(false);
          console.log(error)
        });
    },
  });
const shiftlist = [
  { value: 1, label: "Shift 1" },
  { value: 2, label: "Shift 2" }
];
  
// Add this utility function at the top of your file
const getMonthYear = (dateString) => {
  const date = new Date(dateString);
  return {
    month: date.toLocaleDateString('en-US', { month: 'long' }),
    year: date.getFullYear(),
    formatted: date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
  };
};
  const DownloadSlip = async (employee) => {
    console.log(employee);
    $("#loader-image-"+employee.id).removeClass('loader-hide');
    $("#loader-image-"+employee.id).addClass('loader-show');
    try {
      let season_id = localStorage.getItem("season_id");
         await axios.get(`/employees-cnss-declarations-download/${season_id+'-'+employee.id}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }) .then((response) => {
         const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          
          let file_name = `Suivi CNSS ${employee.month} - ${employee.year} Export Optimum.xlsx`;

          link.download = file_name;
          
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
       
       $("#loader-image-"+employee.id).addClass('loader-hide');
       $("#loader-image-"+employee.id).removeClass('loader-show');
      })

  } catch (error) {
    console.error(error);
  }

  }


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const customHandleInput = (event) => {
  console.log(event);
  //const Input_name = event.target.name;
  //delete backendErrors[Input_name];
};

// const handleChangeDate = (date) => {
//   setDate(date);
// };

const ActionColumn = ({ row }) => {
  return (
    <div>
      <button
        className="btn btn-primary btn-block"
        id={`button-all-${row.original.id}`}
        onClick={() => DownloadSlip(row.original)}
      >
        Download Excel
        <img
          id={`loader-image-${row.original.id}`}
          className="loader-image loader-hide"
          src={loader_image} // Ensure this is defined
          alt="loading"
        />
      </button>
    </div>
  );
};

// ✅ Define PropTypes for ActionColumn
ActionColumn.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Define ActionCell as a separate component
const ActionCell = ({ row }) => <ActionColumn row={row} />;

// ✅ Define PropTypes for ActionCell
ActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

const columnss = [
  {
    header: 'Period',
    accessorFn: (row) => (row.filter_start_date ? row.filter_start_date+' '+row.filter_end_date : ''),
  },
  
  { accessorKey: 'total_employees', header: 'Number of Employees' },
  { accessorKey: 'total_cnss_value', header: 'Total CNSS Amount' },
  // { accessorKey: 'shift_hour', header: 'Total of hours' }, 
  // // { accessorKey: 'extra_hour', header: 'Extra Hour' },
  {
    header: 'ACTION',
    Cell: ActionCell, // ✅ Pass the validated component directly
  },
];



   const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    setFieldValue(name, value);
  };

  //console.log(event);
  const formfilterRef = useRef({
  season_id: season_id,
  cnss: 1,
});
const customHandleStatus = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    emptype: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};
const customHandleLocation = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    location: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};





const customHandleGender = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    gender: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};
const customHandleShift = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    shift: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};
  const fetchEmployees = (filter) => {

    console.log("filter");
    console.log(filter);
  axios.post("/employees/listing-active-emp-for-salary", filter, {
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    if (response.data.code === 200) {
      let employees = response.data.data.employees;
      let emp_statusList = employees.map((ord, index) => ({
        label: `${ord.first_name} ${ord.last_name} (${ord.emp_status.title})`,
        value: ord.id,
        key: `sts-${index}`,
      }));
      setEmployeesList(emp_statusList);
    } else if (response.data.code === 401) {
      window.location.href = "/login";
    } else {
      window.location.href = "/login";
    }
  })
  .catch((error) => {
    console.log(error);
  });
};

console.log(locationLoading);

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">CNSS Declarations follow up</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">CNSS Declarations follow up</li>
                </ul>
              </div>
            
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body" > 
                   <form action="#" onSubmit={handleSubmit} style={{padding:'30px'}}>
                    <h4 className="card-title">CNSS Declarations follow up</h4><br/>
                   
                      <div className="row" >
                      <div className="col-md-2">
                          <div className="form-group">
                            <label>Select Employee Type</label>
                              <Select
                                className="w-100"
                                value={statusOptions.find(option => option.value == values.employee_type) || null} // Ensure correct format
                                name="employee_type"
                                  //onChange={(selectedOption) => handleSelectChange("employee_type", selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("employee_type", selectedOption);
                                    customHandleStatus(selectedOption);
                                  }}
                                onBlur={handleBlur}
                                options={statusOptions}
                                placeholder="Select"
                              />

                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                              <label>Select Location:</label>
                              <Select
                                  options={locationLoading}
                                  name="location"
                                  value={locationLoading.find(option => option.value == values.location) || null} 
                                  //onChange={(selectedOption) => handleSelectChangeOrder(selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("location", selectedOption);
                                    customHandleLocation(selectedOption);
                                  }}
                                />
                            </div>
                          </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Select Employee</label>
                              <Select
                                 className="w-100"
                                 value={employeesList.filter(option => values.employee.includes(option.value))} // Ensure correct selection
                                 name="employee"
                                 onChange={(selectedOptions) => {
                                   const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                   setFieldValue("employee", selectedValues); // ✅ Ensure correct update in Formik state
                                 }}
                                 onBlur={handleBlur}
                                 options={employeesList}
                                 placeholder="Select"
                                 isMulti
                                />

                            </div>
                        </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Select Shift</label>
                                <Select
                                    className="w-100"
                                    value={shiftlist.find(option => option.value === values.shift) || null}

                                    name="shift"
                                  onChange={(selectedOption) => {
                                      handleSelectChange("shift", selectedOption);
                                      customHandleShift(selectedOption);
                                    }}
                                    onBlur={handleBlur}
                                    options={shiftlist}
                                    placeholder="Select"
                                  
                                  />
  
                              </div>
                          </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label>Start Date</label>
                            <input
                              type="date"
                              name="start_date"
                              value={values.start_date}
                              className='form-input form-control'
                             required
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              //  setDefaultDate(e.target.value)
                              }}
                               onBlur={handleBlur}
                            />
                        
																
                          </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                              <label>End Date</label>
                              <input
                                type="date"
                                name="end_date"
                                value={values.end_date}
                                className="form-input form-control"
                                required
                                min={values.start_date || ""} // ✅ Prevent selecting earlier dates
                                onChange={(e) => {
                                  // Ensure End Date >= Start Date
                                  if (values.start_date && e.target.value < values.start_date) {
                                    alert("End Date cannot be earlier than Start Date");
                                    return;
                                  }
                                  handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={handleBlur}
                              />
                            </div>
                          </div>
                           <div className="col-md-2">
                            <div className="form-group">
                              <label>Select Gender</label>
                                <Select
                                    className="w-100"
                                    value={genderlist.find(option => option.value === values.gender) || null}

                                    name="gender"
                                  onChange={(selectedOption) => {
                                      handleSelectChange("gender", selectedOption);
                                      customHandleGender(selectedOption);
                                    }}
                                    onBlur={handleBlur}
                                    options={genderlist}
                                    placeholder="Select"
                                  
                                  />
  
                              </div>
                          </div>
                       <div className="col-md-2">
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={isSubmitting}
                        >
                          Suivi CNSS Excel 
                          <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>
                        </button>
                      </div>
                       </div>
                     
                       
                     
                      </div>
                   
                      
                   
                    </form>
                 
                </div>
              </div>
            </div>
          </div>

          
          <div className="row">
            <div className="col-sm-12">
              {permission && permission.list == 1 && ( 
                <div className="card card-table" style={{padding:'30px'}}>
                  <div className="card-body" > 
                    <h4 className="card-title">CNSS Declarations follow up Listings</h4>
                      <div className="row">
                        <div className="col-sm-12">
                        <div className="table-responsive">
                            <MaterialReactTable columns={columnss} data={dataa} 
                                enableColumnOrdering
                                enablePinning
                              
                              />
                            </div>
                        </div>
                      </div>
                  
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CnssList;
